import inventoryClient from '@modules/clients/inventoryClient';
import { V1UsersUserIdItemsItemTypeItemTargetIdIsOwnedGetItemTypeEnum } from '@rbx/clients/inventory';
import economyClient from '@modules/clients/economyClient';

export type AssetDetailsModel = {
  assetId: number;
  creatorId?: number;
  productId?: number;
  productPrice?: number;
};

// see inventory-api: Roblox.Inventory.Api/Enums/CategoryItemType
const assetItemType = V1UsersUserIdItemsItemTypeItemTargetIdIsOwnedGetItemTypeEnum.NUMBER_0;

export const getIsAssetOwned = async (userId: number, assetId: number): Promise<boolean> => {
  try {
    return await inventoryClient.getIsItemOwned({
      userId,
      itemType: assetItemType,
      itemTargetId: assetId,
    });
  } catch {
    return false;
  }
};

export const getAssetDetails = async (userId: number, assetId: number) => {
  try {
    const response = await economyClient.getAssetDetails({ assetId });
    return {
      assetId,
      creatorId: response.creator?.id,
      productId: response.productId,
      productPrice: response.priceInRobux,
    } as AssetDetailsModel;
  } catch (e) {
    return null;
  }
};

export const postPurchaseAsset = async (userId: number, assetId: number) => {
  let isAddedToInventory = false;
  const assetDetails = await getAssetDetails(userId, assetId);
  if (assetDetails !== undefined && assetDetails?.productId !== undefined) {
    try {
      const response = await economyClient.postPurchaseAsset({
        productId: assetDetails.productId,
        purchaseDetail: {
          expectedPrice: assetDetails.productPrice ?? 0,
          expectedSellerId: assetDetails.creatorId,
        },
      });
      if (response.purchased) {
        isAddedToInventory = true;
      }
    } catch (e) {
      isAddedToInventory = false;
    }
  }

  return isAddedToInventory;
};
